// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

export class FileVideoContainerMetadataBuf {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):FileVideoContainerMetadataBuf {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsFileVideoContainerMetadataBuf(bb:flatbuffers.ByteBuffer, obj?:FileVideoContainerMetadataBuf):FileVideoContainerMetadataBuf {
  return (obj || new FileVideoContainerMetadataBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsFileVideoContainerMetadataBuf(bb:flatbuffers.ByteBuffer, obj?:FileVideoContainerMetadataBuf):FileVideoContainerMetadataBuf {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new FileVideoContainerMetadataBuf()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

pixelFormat():string|null
pixelFormat(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
pixelFormat(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

frameRate():number|null {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readFloat64(this.bb_pos + offset) : null;
}

bitRate():bigint|null {
  const offset = this.bb!.__offset(this.bb_pos, 8);
  return offset ? this.bb!.readUint64(this.bb_pos + offset) : null;
}

colorSpace():string|null
colorSpace(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
colorSpace(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 10);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

colorRange():string|null
colorRange(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
colorRange(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 12);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

colorPrimaries():string|null
colorPrimaries(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
colorPrimaries(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 14);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

colorTransferCharacteristic():string|null
colorTransferCharacteristic(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
colorTransferCharacteristic(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 16);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

chromaLocation():string|null
chromaLocation(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
chromaLocation(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 18);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

aspectRatio():string|null
aspectRatio(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
aspectRatio(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 20);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

codecName():string|null
codecName(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
codecName(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 22);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

codecDescription():string|null
codecDescription(optionalEncoding:flatbuffers.Encoding):string|Uint8Array|null
codecDescription(optionalEncoding?:any):string|Uint8Array|null {
  const offset = this.bb!.__offset(this.bb_pos, 24);
  return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
}

static startFileVideoContainerMetadataBuf(builder:flatbuffers.Builder) {
  builder.startObject(11);
}

static addPixelFormat(builder:flatbuffers.Builder, pixelFormatOffset:flatbuffers.Offset) {
  builder.addFieldOffset(0, pixelFormatOffset, 0);
}

static addFrameRate(builder:flatbuffers.Builder, frameRate:number) {
  builder.addFieldFloat64(1, frameRate, null);
}

static addBitRate(builder:flatbuffers.Builder, bitRate:bigint) {
  builder.addFieldInt64(2, bitRate, null);
}

static addColorSpace(builder:flatbuffers.Builder, colorSpaceOffset:flatbuffers.Offset) {
  builder.addFieldOffset(3, colorSpaceOffset, 0);
}

static addColorRange(builder:flatbuffers.Builder, colorRangeOffset:flatbuffers.Offset) {
  builder.addFieldOffset(4, colorRangeOffset, 0);
}

static addColorPrimaries(builder:flatbuffers.Builder, colorPrimariesOffset:flatbuffers.Offset) {
  builder.addFieldOffset(5, colorPrimariesOffset, 0);
}

static addColorTransferCharacteristic(builder:flatbuffers.Builder, colorTransferCharacteristicOffset:flatbuffers.Offset) {
  builder.addFieldOffset(6, colorTransferCharacteristicOffset, 0);
}

static addChromaLocation(builder:flatbuffers.Builder, chromaLocationOffset:flatbuffers.Offset) {
  builder.addFieldOffset(7, chromaLocationOffset, 0);
}

static addAspectRatio(builder:flatbuffers.Builder, aspectRatioOffset:flatbuffers.Offset) {
  builder.addFieldOffset(8, aspectRatioOffset, 0);
}

static addCodecName(builder:flatbuffers.Builder, codecNameOffset:flatbuffers.Offset) {
  builder.addFieldOffset(9, codecNameOffset, 0);
}

static addCodecDescription(builder:flatbuffers.Builder, codecDescriptionOffset:flatbuffers.Offset) {
  builder.addFieldOffset(10, codecDescriptionOffset, 0);
}

static endFileVideoContainerMetadataBuf(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createFileVideoContainerMetadataBuf(builder:flatbuffers.Builder, pixelFormatOffset:flatbuffers.Offset, frameRate:number|null, bitRate:bigint|null, colorSpaceOffset:flatbuffers.Offset, colorRangeOffset:flatbuffers.Offset, colorPrimariesOffset:flatbuffers.Offset, colorTransferCharacteristicOffset:flatbuffers.Offset, chromaLocationOffset:flatbuffers.Offset, aspectRatioOffset:flatbuffers.Offset, codecNameOffset:flatbuffers.Offset, codecDescriptionOffset:flatbuffers.Offset):flatbuffers.Offset {
  FileVideoContainerMetadataBuf.startFileVideoContainerMetadataBuf(builder);
  FileVideoContainerMetadataBuf.addPixelFormat(builder, pixelFormatOffset);
  if (frameRate !== null)
    FileVideoContainerMetadataBuf.addFrameRate(builder, frameRate);
  if (bitRate !== null)
    FileVideoContainerMetadataBuf.addBitRate(builder, bitRate);
  FileVideoContainerMetadataBuf.addColorSpace(builder, colorSpaceOffset);
  FileVideoContainerMetadataBuf.addColorRange(builder, colorRangeOffset);
  FileVideoContainerMetadataBuf.addColorPrimaries(builder, colorPrimariesOffset);
  FileVideoContainerMetadataBuf.addColorTransferCharacteristic(builder, colorTransferCharacteristicOffset);
  FileVideoContainerMetadataBuf.addChromaLocation(builder, chromaLocationOffset);
  FileVideoContainerMetadataBuf.addAspectRatio(builder, aspectRatioOffset);
  FileVideoContainerMetadataBuf.addCodecName(builder, codecNameOffset);
  FileVideoContainerMetadataBuf.addCodecDescription(builder, codecDescriptionOffset);
  return FileVideoContainerMetadataBuf.endFileVideoContainerMetadataBuf(builder);
}
}
